export default __webpack_public_path__ + "static/media/rovsing_courier.b592cb8b.jpg";